var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSharePrimary1818 = function SvgSharePrimary1818(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#669AFF",
    d: "M13.5 12.09c-.57 0-1.08.225-1.47.578L6.683 9.555c.037-.172.067-.345.067-.525s-.03-.352-.067-.525l5.287-3.083a2.24 2.24 0 0 0 1.53.608 2.247 2.247 0 0 0 2.25-2.25 2.247 2.247 0 0 0-2.25-2.25 2.247 2.247 0 0 0-2.25 2.25c0 .18.03.353.068.525L6.03 7.388A2.24 2.24 0 0 0 4.5 6.78a2.247 2.247 0 0 0-2.25 2.25 2.247 2.247 0 0 0 2.25 2.25 2.24 2.24 0 0 0 1.53-.607l5.34 3.12c-.037.157-.06.322-.06.487 0 1.208.982 2.19 2.19 2.19s2.19-.982 2.19-2.19-.982-2.19-2.19-2.19"
  })));
};
export default SvgSharePrimary1818;